import Api from './api';
import Api2Talk from './api2talk';

// Só templates APROVADOS do número selecionado (mesmo endpoint que a automação de envio via provedor usa).
export const getApprovedByRegistrationNumberRequestId = async (id) => {
  let data = [];
  await Api2Talk.get(`/templatemessage/approved/by-registration-number/${id}`)
    .then(result => { data = result.data; })
    .catch(err => { data = err; });
  return data;
};

// Templates de OPT-IN (type=2) APROVADOS do número. O default é o que tem system=true.
export const getApprovedOptInByRegistrationNumberRequestId = async (id) => {
  let data = [];
  await Api2Talk.get(`/templatemessage/approved/optin/by-registration-number/${id}`)
    .then(result => { data = result.data; })
    .catch(err => { data = err; });
  return data;
};

export const getAll = async (hirerId) => {
  let data = []
  await Api.get(`/templatemessage/all`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};


export const getByRegistrationNumberRequestId = async (id) => { 
  let data = []
  await Api.get(`/templatemessage/registrationnumberrequest/${id}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};

export const getByRegistrationNumberRequestIdAndTemplateType = async (id, templateType) => { 
  let data = []
  await Api.get(`/templatemessage/registrationnumberrequest/${id}/type/${templateType}`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};




